module.exports = __webpack_public_path__ + "img/bg_spring_ruins.54515699.jpg";